import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBookingStore } from '../store/bookingStore';

export const BookingWizard = () => {
  const navigate = useNavigate();
  const currentStep = useBookingStore(state => state.currentStep);
  const quoteData = useBookingStore(state => state.quoteData);
  
  useEffect(() => {
    if (!quoteData) {
      navigate('/');
    }
  }, [quoteData, navigate]);
  
  useEffect(() => {
    // Navigate based on current step
    switch(currentStep) {
      case 1:
        navigate('/booking/select-vehicle');
        break;
      case 2:
        navigate('/booking/service-details');
        break;
      case 3:
        navigate('/booking/confirmation');
        break;
      case 4:
        navigate('/booking/payment');
        break;
      default:
        navigate('/booking/select-vehicle');
    }
  }, [currentStep, navigate]);
  
  return null;
};
